import type { SearchOption } from '../../../../../shared/hooks/use-remote-search-options';

/** The value of the option that adds the typed term; a catalogue entry's id is a uuid, so it cannot clash. */
export const ADD_OPTION_VALUE = '__add__';

/** Same rule as the server's catalogue key: trimmed, whitespace collapsed, lower case. */
export function toCatalogueKey(term: string): string {
  return term.trim().replace(/\s+/g, ' ').toLowerCase();
}

/**
 * The "Add …" option for what was typed, or nothing: not when the user may not add, when nothing is typed, or when a
 * listed value already is that term (ignoring case and spacing), which they pick instead.
 */
export function addOptionFor(term: string, options: SearchOption[], canAdd: boolean): SearchOption | undefined {
  const key = toCatalogueKey(term);
  if (!canAdd || key === '') return undefined;
  if (options.some((option) => toCatalogueKey(option.label) === key)) return undefined;
  return { value: ADD_OPTION_VALUE, label: `Add "${term.trim().replace(/\s+/g, ' ')}"` };
}
